import reportWebVitals from "./reportWebVitals";
import renderCalendar from "./renderCalendar";

reportWebVitals();

declare global {
    interface Window {
        renderCalendar: typeof renderCalendar;
        calendarMethods: ReturnType<typeof renderCalendar>;
    }
}

if (process.env.NODE_ENV === "development") {
    // Render dummy during development
    import("./dummyData").then(
        (dummyData) =>
            (window.calendarMethods = renderCalendar(dummyData.default))
    );
} else {
    // Expose globally for production
    window.renderCalendar = renderCalendar;
}
